import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from "@angular/router";
import { NgbPopover, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsPreviewAllVirtualFoldersHierarchyRequest } from '../../../shared/models/permissions-preview-models/per-pre-all-virtual-folders-hierarchy-request.model';
import { PermissionPreviewNode } from '../../../shared/models/permissions-preview-models/permission-preview-node.model';
import { PermissionsPreview } from '../../../shared/models/permissions-preview-models/permissions-preview.model';
import { PermissionsPreviewVirtualFolderHierarchyRequest } from '../../../shared/models/permissions-preview-models/perPreVirtualFolderHierarchyRequest.model';
import { VirtualFolderPermissionsHierarchyRecord } from '../../../shared/models/permissions-preview-models/virtualFolderPerHierarchyRecord.model';
import { Role } from '../../../shared/models/role.model';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { Workflow } from '../../../shared/models/site-content/workflow.model';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { DataCollectionService } from '../../../shared/services/data-collection.service';
import { PermissionsPreviewService } from '../../../shared/services/permissions-preview.service';


// Pull in jQuery with the following line.
declare let $: any; // Note:  consider using Renderer2 instead.

// Define an internally used map types.
interface IKeytoPermissionNode {
    [fieldName: string]: PermissionPreviewNode;
}

@Component({
    selector: 'app-permissions-preview',
    templateUrl: './permissions-preview.component.html',
    styleUrls: ['./permissions-preview.component.scss'],
    standalone: false
})
export class PermissionsPreviewComponent implements OnInit {
    // Properties.
    private siteWorkflows: Workflow[] = [];
    private siteRoles: Role[] = [];

    private workflowsInHierarchy: Workflow[] = [];
    private initiallySelectedRoles: Role[] = null;
    private selectedRoleNames: string[] = null; // null => All roles selected.

    private tabGroupSelectedIndex: number = 0;

    private permissionsPreviewResponse: PermissionsPreview = null;
    private previousPermissionNodeRoleName: string = null;
    private previousWorkflowStateNames: string[] = null;

    @ViewChildren(NgbPopover, { read: NgbPopover }) popovers: QueryList<NgbPopover>;
    @ViewChildren(NgbPopover, { read: ElementRef }) popoverElementRefs: QueryList<ElementRef>;

    private readonly siteWorkflowName: string = 'Site Workflow (read only)';

    // Constructor.
    public constructor(private currentSiteService: CurrentSiteService,
        private dataCollectionService: DataCollectionService,
        private permissionsPreviewService: PermissionsPreviewService,
        private readonly titleService: Title,
        private route: ActivatedRoute,
        private popoverConfig: NgbPopoverConfig) {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Access the current site.
        let currentSite: DataCollection = this.currentSiteService.Site;

        // Get site workflows.
        this.dataCollectionService.getWorkflowsBySite(currentSite.id).then(responseWorkflows => {
            this.siteWorkflows = responseWorkflows;

            if (this.siteWorkflows.length > 0) {
                //let clonedWorkflow: Workflow = <Workflow>this.siteWorkflows[0].clone();
                //let clonedWorkflow: Workflow = this.siteWorkflows[0];
                //let clonedWorkflow: Workflow = this.siteWorkflows.find(wf => wf.name == 'Site Workflow');
                let clonedWorkflow: Workflow = this.siteWorkflows.find(wf => wf.name == this.siteWorkflowName);
                if (clonedWorkflow != null) {
                    this.workflowsInHierarchy.push(clonedWorkflow);
                }

                clonedWorkflow = this.siteWorkflows.find(wf => wf.name == 'Workflow 1-2-3-4');
                if (clonedWorkflow != null) {
                    this.workflowsInHierarchy.push(clonedWorkflow);
                }
            }
        });

        // Get site roles.
        //this.roleService.getRolesForSite(this.currentSiteService.Site.id).then(responseRoles => {this.siteRoles = responseRoles;});
        this.siteRoles = currentSite.roles;
        if ((this.siteRoles != null) && (this.siteRoles.length > 0)) {
            this.initiallySelectedRoles =
                //this.siteRoles.filter(r => (r.name == 'Site Administrator') || (r.name == 'Contributor'));
                this.siteRoles;
        }

        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.currentSiteService.Site.name);

        return;
    }

    // Accessor methods used by my HTML code.
    public get Title(): string {
        return ('Permissions Preview');
    }

    public get SiteWorkflows(): Workflow[] {
        return (this.siteWorkflows);
    }

    public get InitialWorkflowHierarchy(): Workflow[] {
        return (this.workflowsInHierarchy);
    }

    public get SiteRoles(): Role[] {
        return (this.siteRoles);
    }

    public get InitiallySelectedRoles(): Role[] {
        return (this.initiallySelectedRoles);
    }

    public get TabGroupSelectedIndex(): number {
        return (this.tabGroupSelectedIndex);
    }

    public get NumWorkflowsInHierarchy(): number {
        let numWorkflows: number = 0;

        if (this.workflowsInHierarchy != null) {
            numWorkflows = this.workflowsInHierarchy.length;
        }

        return (numWorkflows);
    }

    public get NoWorkflowsInHierarchy(): boolean {
        return (this.workflowsInHierarchy.length == 0);
    }

    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'below';

        return (position);
    }

    public get GeneratePreviewButtonTooltip(): string {
        let tooltip: string = 'Click to generate a permissions preview';

        return (tooltip);
    }

    public get PermissionPreviewNodes(): PermissionPreviewNode[] {
        //return (this.permissionPreviewNodes);
        return (this.permissionsPreviewResponse != null ? this.permissionsPreviewResponse.permissionNodes : null);
    }

    public IsLastPermissionPreviewNode(nodeIndex: number): boolean {
        let isLastNode: boolean = false;

        //if (this.permissionPreviewNodes != null)
        if ((this.permissionsPreviewResponse != null) && (this.permissionsPreviewResponse.permissionNodes != null)) {
            //isLastNode = (nodeIndex >= this.permissionPreviewNodes.length - 1);
            isLastNode = (nodeIndex >= this.permissionsPreviewResponse.permissionNodes.length - 1);
        }

        return (isLastNode);
    }

    public PermissionsPreviewRowClass(nodeIndex: number): string {
        let rowClass: string =
            (nodeIndex % 2 == 1 ? 'permission-results-table-odd-tr' : 'permission-results-table-even-tr');

        return (rowClass);
    }

    public get PermissionsPreviewWorkflowHierarchy(): Workflow[] {
        //return (this.permissionsPreview != null ? this.permissionsPreview.workflowHierarchy : []);
        return (this.permissionsPreviewResponse != null ? this.permissionsPreviewResponse.workflowHierarchy : []);
    }

    public get PermissionsPreviewWorkflowCount(): number {
        //return (this.permissionsPreview != null ? this.permissionsPreview.workflowHierarchy.length : 0);
        return (this.permissionsPreviewResponse != null ? this.permissionsPreviewResponse.workflowHierarchy.length : 0);
    }

    public PermissionNodeRoleName(permissionNode: PermissionPreviewNode, nodeIndex: number): string {
        let nodeRoleName: string = '';

        if (nodeIndex == 0) {
            nodeRoleName = permissionNode.roleName;
        } else if (permissionNode.roleName != this.previousPermissionNodeRoleName) {
            nodeRoleName = permissionNode.roleName;
        }

        this.previousPermissionNodeRoleName = permissionNode.roleName;

        return (nodeRoleName);
    }

    public PermissionNodeWorkflowState(permissionNode: PermissionPreviewNode, workflowIndex: number): string {
        // Note:  this logic should be changed to put the previous workflow states in the permissionNode itself.
        let workflowState: string = '';

        if ((this.previousWorkflowStateNames != null) &&
            (workflowIndex < this.previousWorkflowStateNames.length)) {
            let workflowStates: string[] = permissionNode.folderName.split('->');

            if (workflowIndex < workflowStates.length) {
                if (workflowStates[workflowIndex] != this.previousWorkflowStateNames[workflowIndex]) {
                    workflowState = workflowStates[workflowIndex];

                    this.previousWorkflowStateNames[workflowIndex] = workflowState;
                }
            }
        }

        return (workflowState);
    }

    public PermissionNodeWorkflowsString(permissionNode: PermissionPreviewNode, nodeIndex: number): string {
        let workflows: string = '';

        if (nodeIndex == 0) {
            //workflows = permissionNode.workflowAndState;
            workflows = permissionNode.folderName;
        } else {
            // TO DO:  ADD THE LOGIC TO NOT REPEAT PARTS OF THE WORKFLOW STRING
            //workflows = permissionNode.workflowAndState;
            workflows = permissionNode.folderName;
        }

        return (workflows);
    }

    public WorkflowHierarchyShown(permissionNode: PermissionPreviewNode): boolean {
        //let isShown: boolean = ((permissionNode.transientVirtualFolderHierarchyResponse != null) && permissionNode.transientIsShown);
        let isShown: boolean = ((permissionNode.transientHierarchyRecords != null) && permissionNode.transientIsShown);

        return (isShown);
    }

    public WorkflowHierarchyRecords(permissionNode: PermissionPreviewNode): VirtualFolderPermissionsHierarchyRecord[] {
        /*
        let hierarchyRecords: VirtualFolderPermissionsHierarchyRecord[] =
            (permissionNode.transientVirtualFolderHierarchyResponse != null ?
                permissionNode.transientVirtualFolderHierarchyResponse.hierarchyRecords : []);

        return (hierarchyRecords);
        */
        return permissionNode.transientHierarchyRecords;
    }

    public get BuildPermissionCellNames(): string[] {
        return ['canBuildRoles', 'canBuildWorkflows', 'canBuildForms', 'canBuildFolders', 'CanBuildFormInstances'];
    }

    public get PerformPermissionCellNames(): string[] {
        return ['canView', 'canEdit', 'canDelete', 'canGrant'];
    }

    public CanBuild(hierarchyRecord: VirtualFolderPermissionsHierarchyRecord, permissionCellName: string): boolean {
        /*
        let canBuild: boolean = hierarchyRecord[permissionCellName];

        return (canBuild);
        */
        return hierarchyRecord.canBuild(permissionCellName);
    }

    public CanPerform(hierarchyRecord: VirtualFolderPermissionsHierarchyRecord, permissionCellName: string): boolean {
        /*
        let canPerform: boolean = hierarchyRecord[permissionCellName]

        return (canPerform);
        */
        return hierarchyRecord.canPerform(permissionCellName);
    }

    public VirtualFolderHierarchyTitle(permissionNode: PermissionPreviewNode): string {
        //return (permissionNode.folderName);
        let readableFolderName: string = permissionNode.folderName.replace(/\-\>/g, " to ");
        let title: string = `${permissionNode.roleName}:  ${readableFolderName}`;
        return title;
    }

    public PermissionNodeId(permissionNode: PermissionPreviewNode): string {
        //let id: string = `td-${permissionNode.transientClientId}`;
        let id: string = `tr-${permissionNode.id}`;
        return id;
    }

    public ClickedPermissionName(permissionNode: PermissionPreviewNode): string {
        return permissionNode.transientPermissionNameClicked;
    }
    // End accessor methods.

    // Handle control events.
    public onWorkflowHierarchyUpdated(workflowsInHierarchyParam: Workflow[]): void {
        this.workflowsInHierarchy = workflowsInHierarchyParam;

        return;
    }

    public onSelectedRolesUpdated(selectedRoleNamesParam: string[]): void {
        this.selectedRoleNames = selectedRoleNamesParam;

        return;
    }

    public generatePermissionsPreview(): void {
        //  Clear any existing permission results data.
        //this.permissionPreviewNodes = null;
        this.permissionsPreviewResponse = null;

        // Construct a permission preview model object.
        /*
        this.permissionsPreview = new PermissionsPreview();
        this.permissionsPreview.dataCollectionId = this.currentSiteService.Site.id;
        this.permissionsPreview.workflowHierarchy = this.workflowsInHierarchy;
        if ((this.selectedRoleNames != null) && (this.selectedRoleNames.length > 0)) {
            this.permissionsPreview.selectedRoleNames = this.selectedRoleNames;
        }
        */
        let permissionsPreviewRequest: PermissionsPreview = new PermissionsPreview();
        permissionsPreviewRequest.dataCollectionId = this.currentSiteService.Site.id;
        permissionsPreviewRequest.workflowHierarchy = this.workflowsInHierarchy;
        if ((this.selectedRoleNames != null) && (this.selectedRoleNames.length > 0)) {
            permissionsPreviewRequest.selectedRoleNames = this.selectedRoleNames;
        }

        // Ask the service to request the preview.
        //this.permissionsPreviewService.generatePermissionsPreview(this.permissionsPreview).then(response => {
        this.permissionsPreviewService.generatePermissionsPreview(permissionsPreviewRequest).then(response => {
            this.permissionsPreviewResponse = response;

            //this.permissionPreviewNodes = response.permissionNodes;
            //this.permissionPreviewNodes = this.permissionsPreviewResponse.permissionNodes;

            // Note:  the values for this.previousWorkflowStateNames is set in PermissionNodeWorkflowState(), above.
            this.previousWorkflowStateNames = [];
            //for (let iWorkflow: number = 0; iWorkflow < this.permissionsPreview.workflowHierarchy.length; iWorkflow++) {
            for (let iWorkflow: number = 0; iWorkflow < this.permissionsPreviewResponse.workflowHierarchy.length; iWorkflow++) {
                this.previousWorkflowStateNames.push('');
            }

            // Load the folder hierarchy records for all permission preview nodes.
            this.loadAllPermissionNodeFolderHierarchies();
        });

        return;
    }

    public permissionClicked(permissionNode: PermissionPreviewNode, permissionName: string): void {
        // Prepare a request.
        let request: PermissionsPreviewVirtualFolderHierarchyRequest = new PermissionsPreviewVirtualFolderHierarchyRequest();
        request.dataCollectionId = this.permissionsPreviewResponse.dataCollectionId;
        request.workflowHierarchy = this.permissionsPreviewResponse.workflowHierarchy;
        request.allRoleNames = [];
        for (let iIndex: number = 0; iIndex < this.siteRoles.length; iIndex++) {
            request.allRoleNames.push(this.siteRoles[iIndex].name);
        }
        request.virtualFolderId = permissionNode.folderId;
        request.selectedRoleName = permissionNode.roleName;

        // Request the node's virtual folder hierarchy records.
        this.permissionsPreviewService.generateVirtualFolderHierarchyRecords(request).then(response => {
            permissionNode.transientPermissionNameClicked = permissionName;
            this.onePermissionNodeFolderHierarchyLoaded(permissionNode, response.hierarchyRecords);
        });

        return;
    }
    // End control event handlers.

    // Private helper methods.
    private onePermissionNodeFolderHierarchyLoaded(permissionNode: PermissionPreviewNode, hierarchyRecords: VirtualFolderPermissionsHierarchyRecord[]): void {
        permissionNode.transientHierarchyRecords = hierarchyRecords;
        permissionNode.transientIsShown = true;

        let arrPopoverElementRefs: ElementRef[] = this.popoverElementRefs.toArray();
        let arrPopovers: NgbPopover[] = this.popovers.toArray();
        if ((arrPopoverElementRefs != null) && (arrPopovers != null)) {
            let permissionNodeId: string = this.PermissionNodeId(permissionNode);
            let permissionNodePopover: NgbPopover = null;

            for (let iPop: number = 0; iPop < arrPopoverElementRefs.length; iPop++) {
                let popElementRef: ElementRef = arrPopoverElementRefs[iPop];

                if (popElementRef.nativeElement.id == permissionNodeId) {
                    if (iPop < arrPopovers.length) {
                        permissionNodePopover = arrPopovers[iPop];
                    }

                    break;
                }
            }

            // We have considered the popover to be triggered in code.
            if (permissionNodePopover != null) {
                permissionNodePopover.open();
            }
            $('ngb-popover-window').css({
                "min-width": "700px",
                "max-width": "700px"
            });
        }
        // Done.
    }

    private loadAllPermissionNodeFolderHierarchies(): void {
        // Prepare request.
        let request: PermissionsPreviewAllVirtualFoldersHierarchyRequest = new PermissionsPreviewAllVirtualFoldersHierarchyRequest();
        //request.dataCollectionId = this.permissionsPreview.dataCollectionId;
        request.dataCollectionId = this.permissionsPreviewResponse.dataCollectionId;
        //request.workflowHierarchy = this.permissionsPreview.workflowHierarchy;
        request.workflowHierarchy = this.permissionsPreviewResponse.workflowHierarchy;
        request.allRoleNames = [];
        for (let iIndex: number = 0; iIndex < this.siteRoles.length; iIndex++) {
            request.allRoleNames.push(this.siteRoles[iIndex].name);
        }
        //request.distinctFolderIdList = this.permissionsPreview.distinctFolderIdList;
        request.distinctFolderIdList = this.permissionsPreviewResponse.distinctFolderIdList;

        // Request the virtual folder hierarchy for all permission nodes.
        this.permissionsPreviewService.generateAllVirtualFoldersHierarchyRecords(request).then(response => {
            // this.allPermissionNodeFolderHierarchiesLoaded(response);
            let bResult: boolean = this.setAllPermissionNodesFolderHierarchies(response);
            let message: string = `setAllPermissionNodesFolderHierarchies() returned ${bResult}.`;
            console.log(message);
        });

        return;
    }

    /*
    private allPermissionNodeFolderHierarchiesLoaded(response: PermissionsPreviewAllVirtualFoldersHierarchyRequest): void {
        this.virtualFolderHierarchiesLoaded = new Observable<boolean>(observer => {
            let result: boolean = this.setAllPermissionNodesFolderHierarchies(response);
            observer.next(result);

            observer.complete();
        });

        this.virtualFolderHierarchiesLoaded.subscribe(bResult => {
            let message: string = `setAllPermissionNodesFolderHierarchies() returned ${bResult}.`;
            console.log(message);
        });

        return;
    }
    */

    private setAllPermissionNodesFolderHierarchies(response: PermissionsPreviewAllVirtualFoldersHierarchyRequest): boolean {
        let result: boolean = false;

        if (this.permissionsPreviewResponse != null) {
            // Create a map of permission node keys to permission nodes.
            let mapOfKeyToPermissionNode: IKeytoPermissionNode = {};
            //for (let iNode: number = 0; iNode < this.permissionPreviewNodes.length; iNode++) {
            for (let iNode: number = 0; iNode < this.permissionsPreviewResponse.permissionNodes.length; iNode++) {
                //let node: PermissionPreviewNode = this.permissionPreviewNodes[iNode];
                let node: PermissionPreviewNode = this.permissionsPreviewResponse.permissionNodes[iNode];
                //let key: string = `${node.folderId}-${node.roleId}`;
                let key: string = PermissionsPreviewComponent.genPermissionNodeKeyFrom(node.folderId, node.roleId);

                mapOfKeyToPermissionNode[key] = node;
            }

            // Process the returned folder hierarchy records.
            for (let iRecord: number = 0; iRecord < response.hierarchyRecords.length; iRecord++) {
                let hierarchyRecord: VirtualFolderPermissionsHierarchyRecord = response.hierarchyRecords[iRecord];
                //let key: string = `${hierarchyRecord.folderId}-${hierarchyRecord.roleId}`;
                let key: string = PermissionsPreviewComponent.genPermissionNodeKeyFrom(hierarchyRecord.folderId, hierarchyRecord.roleId);
                let permissionNode: PermissionPreviewNode = mapOfKeyToPermissionNode[key];

                if (permissionNode == null) {
                    let errorMessage: string =
                        `PermissionsPreviewComponent.setAllPermissionNodesFolderHierarchies():  could not find a permission node with key value ${key}`;
                    throw errorMessage;
                }

                if (permissionNode.transientHierarchyRecords == null) {
                    permissionNode.transientHierarchyRecords = [];
                }

                permissionNode.transientHierarchyRecords.push(hierarchyRecord);
            }

            result = true;
        }

        return result;
    }

    private static genPermissionNodeKeyFrom(folderId: number, roleId: number): string {
        let key: string = `${folderId}-${roleId}`;

        return key;
    }
}
